import ObjectUtil from '@component/common/src/util/ObjectUtil';

class Format {
  constructor(field) {
    this.field = field;
  }
  isNull() {
    return ['', null, undefined].indexOf(this.field) !== -1;
  }
}

class FormatString extends Format {
  transform() {
    return [String(this.field || '')];
  }
}

class FormatCurrency extends Format {
  getNumber() {
    if (typeof this.field === 'string') {
      const num = this.field.replace(/[,]+/g, '');
      return Number.isNaN(Number(num)) ? 0 : num;
    }
    return this.field || 0;
  }
  transform() {
    return [Number(this.getNumber()).toFixed(2).toString()];
  }
}

class FormatNumber extends Format {
  transform() {
    return [Number.parseInt(this.field || 0, 10).toString()];
  }
}

class FormatBoolean extends Format {
  getBool() {
    if (this.isNull()) {
      return '';
    } else if (typeof this.field === 'boolean') {
      return this.field;
    } else if (typeof this.field === 'string') {
      try {
        return typeof JSON.parse(this.field) === 'boolean' ? this.field : '';
      } catch (e) {
        return '';
      }
    } else {
      return '';
    }
  }
  transform() {
    return [String(this.getBool())];
  }
}

class FormatIsNotEmpty extends Format {
  getField() {
    return this.isNull() ? '' : this.field;
  }
  transform() {
    return [String(this.getField())];
  }
}

class FormatArray extends Format {
  getField() {
    if (this.isNull()) {
      return [''];
    }
    return Array.isArray(this.field) ? this.field.map(v => String(v)) : [''];
  }
  transform() {
    return this.getField();
  }
}

class UnformatValue extends Format {
  getField() {
    if (this.field && this.field.constructor.name === 'Array') {
      return this.field.shift().toString();
    }
    return '';
  }

  transform() {
    return this.getField();
  }
}

export const getDeliveryType = (productModel) => {
  const deliveryType = [];
  let deliveryTypeVendorDirect = false;
  let deliveryTypeMacys = false;
  if (ObjectUtil.hasChildProperty(productModel.get('viewState'), 'detail.selectedUpcItem.availability.availabilityMessage')) {
    const currentShippingMessage = ObjectUtil.getChildProperty(productModel.get('viewState'), 'detail.selectedUpcItem.availability.availabilityMessage');
    if (currentShippingMessage === 'Direct from vendor') {
      deliveryTypeVendorDirect = true;
    }
  }

  if (ObjectUtil.hasChildProperty(productModel.get('viewState'), 'detail.selectedUpcItem.availability.storeAvailability')) {
    const macysOwnShipping = ObjectUtil.getChildProperty(productModel.get('viewState'), 'detail.selectedUpcItem.availability.storeAvailability');
    if (macysOwnShipping) {
      deliveryTypeMacys = true;
    }
  }

  if (deliveryTypeVendorDirect && deliveryTypeMacys) {
    deliveryType.push('both');
  } else {
    if (deliveryTypeVendorDirect) {
      deliveryType.push('vendor direct');
    }
    if (deliveryTypeMacys) {
      deliveryType.push('own');
    }
  }
  return deliveryType;
};


export const STRING = 'string';
export const CURRENCY = 'currency';
export const NUMBER = 'number';
export const BOOL = 'bool';
export const NOT_EMPTY = 'notempty';
export const UNFORMAT = 'unformat';
export const ARRAY = 'array';

export function format(field, type = STRING) {
  switch (type) {
    case STRING:
      return new FormatString(field).transform();
    case CURRENCY:
      return new FormatCurrency(field).transform();
    case NUMBER:
      return new FormatNumber(field).transform();
    case BOOL:
      return new FormatBoolean(field).transform();
    case NOT_EMPTY:
      return new FormatIsNotEmpty(field).transform();
    case UNFORMAT:
      return new UnformatValue(field).transform();
    case ARRAY:
      return new FormatArray(field).transform();
    default:
      throw new Error('Format not available');
  }
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/TealiumFormattingUtil.js